import React, { Component } from 'react';
import { Form, FormGroup, Label, Col } from '@Comp';
import { TextField } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import DocumentUploader from '../dropzone';
import ViewUploadedFiles from '../ViewUploadeFiles';
import validate from 'validate.js';
import { businessAddressSchema } from '../ValidationSchemas';
import { AreaCategories, BusinessAddresses } from '../../../services/requests';
@inject('businessProfileStore', 'commonStore')
@observer
class BusinessAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: undefined,
            businessAddressData: {
                description: '',
                unitNo: '',
                streetName: '',
                suburb: '',
                city: '',
                province: '',
                postalCode: '',
                proofOfAddress: [],
                companyDetails: null,
                complete: false,
                id: null,
                areaCategory: null
            },
            fetchClick:false,
            areaCategories: [],
            selectedAreaCategory: null,
            categoriesFetched: false,
            categoriesLoading: false
        };
        this.formState = {
            isValid: false,
            values: {},
            touched: {},
            errors: {}
        };
    }

    async componentDidMount() {
        const { companyDetails } = this.props.businessProfileStore.businessProfile;
        if (companyDetails && companyDetails.businessAddress) {
            const businessAddressData = companyDetails.businessAddress;
            this.setState({
                businessAddressData
            });
        }

        if (!this.state.categoriesFetched && !this.state.categoriesLoading) {
            await this.fetchAreaCategories();
        }
    }

    fetchAreaCategories = async () => {
        if (this.state.categoriesLoading || this.state.categoriesFetched) {
            return;
        }

        this.setState({ categoriesLoading: true });

        try {
            const response = await AreaCategories.getAll();
            console.log('Area Categories API Response:', response);

            if (response && response.data) {
                const responseData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                console.log('Area Categories Data:', responseData);

                if (responseData.length > 0) {
                    // Map to ensure consistent structure
                    const mappedCategories = responseData.map(cat => ({
                        id: cat.id || cat._id,
                        name: cat.name,
                        description: cat.description
                    }));

                    this.setState({
                        areaCategories: mappedCategories,
                        categoriesLoading: false,
                        categoriesFetched: true
                    });
                } else {
                    console.warn('Area categories response is empty');
                    this.setState({
                        areaCategories: [],
                        categoriesLoading: false,
                        categoriesFetched: true
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching area categories:', error);
            console.error('Error details:', error.response || error.message);
            this.setState({
                areaCategories: [],
                categoriesLoading: false,
                categoriesFetched: true
            });
        }
    };

    loadExistingAreaCategory = () => {
        const { companyDetails } = this.props.businessProfileStore.businessProfile;
        if (companyDetails && companyDetails.businessAddress && companyDetails.businessAddress.areaCategory) {
            const categoryId = typeof companyDetails.businessAddress.areaCategory === 'string'
                ? companyDetails.businessAddress.areaCategory
                : companyDetails.businessAddress.areaCategory.id || companyDetails.businessAddress.areaCategory._id;

            const category = this.state.areaCategories.find(c => c.id === categoryId);
            if (category) {
                this.setState({ selectedAreaCategory: category });
            }
        }
    };

    componentDidUpdate(prevProps, prevState){
        // Load existing area category after categories are fetched
        if (!prevState.categoriesFetched && this.state.categoriesFetched && this.state.areaCategories.length > 0) {
            this.loadExistingAreaCategory();
        }

        if(this.props.fetchClick && !this.state.fetchClick){
            const { companyDetails } = this.props.businessProfileStore.businessProfile;
            if (companyDetails && companyDetails.businessAddress) {
                this.setState({
                    businessAddressData: companyDetails.businessAddress,
                    fetchClick:true
                }, () => {
                    // Reload area category after fetchClick
                    if (this.state.categoriesFetched) {
                        this.loadExistingAreaCategory();
                    }
                });
            }
        }
    }
    handleChange = e => {
        const { name, value } = e.target;
        this.formState = {
            ...this.formState,
            values: {
                ...this.formState.values,
                [name]: value
            },
            touched: {
                ...this.formState.touched,
                [name]: true
            }
        };

        const errors = validate(this.formState.values, businessAddressSchema);
        let bool = true;
        if (errors) {
            bool = false;
        }
        this.formState = {
            ...this.formState,
            isValid: bool,
            errors: errors || {}
        };

        this.setState(
            {
                businessAddressData: { ...this.state.businessAddressData, [name]: value }
            },
            () => {
                this.props.formDataChange(this.state.businessAddressData, 'businessAddress');
                this.props.businessProfileStore.businessAddress = this.state.businessAddressData;
            }
        );
        this.props.businessProfileStore.fieldsToUpdate.businessAddressDirty = true;
    };

    handleAreaCategoryChange = (e) => {
        const categoryId = e.target.value;
        const category = this.state.areaCategories.find(c => c.id === categoryId);

        this.setState({
            selectedAreaCategory: category,
            businessAddressData: { ...this.state.businessAddressData, areaCategory: categoryId }
        }, () => {
            this.props.businessProfileStore.businessAddress = this.state.businessAddressData;
            this.props.businessProfileStore.fieldsToUpdate.businessAddressDirty = true;
        });
    };

    hasError = field => {
        let bool = false;
        if (this.formState.touched[field] && this.formState.errors[field]) {
            bool = true;
        }
        return bool;
    };

    handleRemoveDocument = (e, documentId) => {
        this.props.businessProfileStore.businessProfile.companyDetails.businessAddress.proofOfAddress =
            this.props.businessProfileStore.businessProfile.companyDetails.businessAddress.proofOfAddress.filter(
                document => document.id !== documentId
            );
    };

    ErrorMsg = field => {
        const hasError = this.hasError(field);
        if (hasError) {
            return this.formState.errors[field][0];
        }
        return null;
    }

    render() {
        const { companyDetails, isEditable } = this.props.businessProfileStore.businessProfile;
        const businessProfile = this.props.businessProfileStore.businessProfile;
        const fileInfo = {
            files: [],
            path: '/public/upload',
            refId: companyDetails && companyDetails.businessAddress && companyDetails.businessAddress._id,
            ref: 'businessaddress',
            source: 'content-manager',
            field: 'proofOfAddress'
        };

        return (
            <div>
                <h5 className="mt-4 mb-3">Business Address</h5>
                <div className="row">
                    <Form
                        method="post"
                        action="/upload"
                        encType="multipart/form-data"
                        className="m-t-15 companyInfo col-12"
                        id="businessAddress"
                        name="businessAddress"
                    >
                        <FormGroup className="row">
                            <Label
                                className="col-sm-2 col-form-label control-label text-sm-right"
                                htmlFor="UnitNo"
                            >
                                Building Name &amp; Unit No.
                            </Label>
                            <Col sm={10}>
                                <TextField
                                    id="unitNo"
                                    name="unitNo"
                                    type="text"
                                    className="form-control businessAddress"
                                    placeholder="BuildingName/UnitNo"
                                    value={this.state.businessAddressData.unitNo}
                                    onChange={this.handleChange}
                                    error={this.hasError('unitNo')}
                                    helperText={
                                        this.ErrorMsg('unitNo')
                                    }
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup className="row">
                            <label className="col-sm-2 col-form-label control-label text-sm-right">
                                Street Name
                            </label>
                            <Col sm-={0}>
                                <TextField
                                    id="streetName"
                                    name="streetName"
                                    type="text"
                                    className="form-control businessAddress"
                                    placeholder="StreetName"
                                    value={this.state.businessAddressData.streetName}
                                    onChange={this.handleChange}
                                    error={this.hasError('streetName')}
                                    helperText={
                                        this.ErrorMsg('streetName')
                                    }
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup className="row">
                            <Label className="col-sm-2 col-form-label control-label text-sm-right">
                                Suburb
                            </Label>
                            <Col sm={10}>
                                <TextField
                                    id="suburb"
                                    name="suburb"
                                    type="text"
                                    className="form-control businessAddress"
                                    placeholder="Suburb"
                                    value={this.state.businessAddressData.suburb}
                                    onChange={this.handleChange}
                                    error={this.hasError('suburb')}
                                    helperText={
                                        this.ErrorMsg('suburb')
                                    }
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label className="col-sm-2 col-form-label control-label text-sm-right">
                                City/Town
                            </Label>
                            <Col sm={10}>
                                <TextField
                                    id="city"
                                    name="city"
                                    type="text"
                                    className="form-control businessAddress"
                                    placeholder="City/Town"
                                    value={this.state.businessAddressData.city}
                                    onChange={this.handleChange}
                                    error={this.hasError('city')}
                                    helperText={
                                        this.ErrorMsg('city')}
                                />
                            </Col>
                        </FormGroup>
                        <div className="form-group row">
                            <Label className="col-sm-2 col-form-label control-label text-sm-right">
                                Province
                            </Label>
                            <Col sm={10}>
                                <TextField
                                    id="province"
                                    name="province"
                                    type="text"
                                    className="form-control businessAddress"
                                    placeholder="Province"
                                    value={this.state.businessAddressData.province}
                                    onChange={this.handleChange}
                                    error={this.hasError('province')}
                                    helperText={
                                        this.ErrorMsg('province')
                                    }
                                />
                            </Col>
                        </div>
                        <FormGroup className="row">
                            <Label className="col-sm-2 col-form-label control-label text-sm-right">
                                Postal Code
                            </Label>
                            <Col sm={10}>
                                <TextField
                                    id="postalCode"
                                    name="postalCode"
                                    className="form-control businessAddress"
                                    placeholder="PostalCode"
                                    minLength="4"
                                    maxLength="4"
                                    value={this.state.businessAddressData.postalCode}
                                    onChange={this.handleChange}
                                    error={this.hasError('postalCode')}
                                    helperText={
                                        this.ErrorMsg('postalCode')
                                    }
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup className="row">
                            <Label className="col-sm-2 col-form-label control-label text-sm-right">
                                Area Category
                            </Label>
                            <Col sm={10}>
                                <select
                                    id="areaCategory"
                                    name="areaCategory"
                                    className="form-control businessAddress"
                                    value={this.state.selectedAreaCategory ? this.state.selectedAreaCategory.id : ''}
                                    onChange={this.handleAreaCategoryChange}
                                    disabled={!businessProfile.isEditable || this.state.areaCategories.length === 0}
                                    style={{ height: '40px' }}
                                >
                                    <option value="">
                                        {this.state.areaCategories.length === 0 ? 'No area categories available' : 'Select area category...'}
                                    </option>
                                    {this.state.areaCategories.map(category => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                               
                                {this.state.areaCategories.length === 0 && (
                                    <small className="form-text text-danger">
                                        No area categories found. Please contact your administrator to set up area categories.
                                    </small>
                                )}
                            </Col>
                        </FormGroup>
                    </Form>
                </div>
                <div className="row">
                    {companyDetails?.businessAddress && companyDetails?.businessAddress?.proofOfAddress && companyDetails?.businessAddress?.proofOfAddress?.length > 0 && (
                        <div className="w-100 d-flex justify-content-center">
                            <ViewUploadedFiles
                                title="Proof Of Address"
                                data={companyDetails.businessAddress.proofOfAddress}
                                handleRemoveDocument={this.handleRemoveDocument}
                            />
                        </div>
                    )}
                    {companyDetails?.businessAddress && companyDetails?.businessAddress?.proofOfAddress && companyDetails?.businessAddress?.proofOfAddress.length < 1 && this.props.isDocumentUploadVisible && (
                        <div className="offset-2 col-10 eightth-step">
                            <DocumentUploader
                                fileData={fileInfo}
                                maxFiles={1}
                                multiple={true}
                                inputContent={'Upload Proof of Address'}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default BusinessAddress;
